import type { ReactNode } from 'react'
import { cn } from '@ondit/ui'
import { cva } from 'class-variance-authority'

export const emptyStateVariants = cva('empty-state', {
  variants: {
    size: { default: 'empty-state--default', compact: 'empty-state--compact' },
  },
  defaultVariants: { size: 'default' },
})

export interface EmptyStateProps {
  title: string
  description?: string
  graphic?: ReactNode
  action?: ReactNode
  size?: 'default' | 'compact'
  className?: string
}

/** Pass feature-specific copy and actions; the default graphic is decorative. */
export function EmptyState({
  title,
  description,
  graphic,
  action,
  size,
  className,
}: EmptyStateProps) {
  return (
    <div className={cn(emptyStateVariants({ size }), className)}>
      <div className='empty-state__graphic' aria-hidden='true'>
        {graphic ?? (
          <svg className='empty-state__illustration' viewBox='0 0 80 64' fill='none'>
            <circle cx='40' cy='32' r='29' className='empty-state__halo' />
            <g stroke='currentColor' strokeWidth='1.5' strokeLinecap='round' strokeLinejoin='round'>
              <rect x='27' y='12' width='26' height='32' rx='4' className='empty-state__paper' />
              <path d='M33 21h14M33 27h10' className='empty-state__rule' />
              <path d='m20 35 5-11h2m26 0h2l5 11' />
              <path
                d='M20 35h12l3 6h10l3-6h12v14a4 4 0 0 1-4 4H24a4 4 0 0 1-4-4Z'
                className='empty-state__paper'
              />
            </g>
          </svg>
        )}
      </div>
      <div className='empty-state__copy'>
        <p className='empty-state__title'>{title}</p>
        {description ? <p className='empty-state__description'>{description}</p> : null}
      </div>
      {action ? <div className='empty-state__actions'>{action}</div> : null}
    </div>
  )
}
